import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	characterLimitErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	invalidUrlErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	characterLimitErrorMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.text-area-picker-popup.character-limit-error-message',
		defaultMessage: "You've reached the character limit ({maxChars})",
		description: 'Display character error when the user has exceeded the character limit',
	},
	invalidUrlErrorMessage: {
		id: 'jql-builder-basic.jql-editor.field.text-area-picker.text-area-picker-popup.invalid-url-error-message',
		defaultMessage: 'Please enter a valid URL.',
		description: 'Display error when the user has entered an invalid URL',
	},
});
export default messages;
